import React, { useState, useEffect } from 'react';
import {
    Shield,
    Zap,
    Phone,
    MessageSquare,
    Users,
    BarChart3,
    Video,
    Bot,
    CheckCircle2,
    Star,
    ArrowRight
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from "./layout/Header";
import Plans from "./layout/UpgradePricingPage";

const ServicesPlans = () => {
    const navigate = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState(null);


    return (
        <div className="w-full min-h-screen bg-white">

            <Header />


            <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
                <Plans />
            </main>
        </div>
    );
};

export default ServicesPlans;
